





























import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableList extends Vue {
  @Prop() private variableList!: any;
  @Prop() private options!: any;
  @Prop() private headerOptions!: any;

  /**
   * 初期化
   */
  private created() {
    for (const colIndex of Object.keys(this.variableList)) {
      if (!Array.isArray(this.variableList[colIndex].value)) {
        // 配列なしの場合初期化
        this.variableList[colIndex].value = [];
        for (const optionIndex of Object.keys(this.options)) {
          if (this.variableList[colIndex].objType === 'fc-hidden') {
            this.variableList[colIndex].value.push(this.options[optionIndex].value);
          } else {
            this.variableList[colIndex].value.push('');
          }
        }
      }
    }
  }
  @Emit('emitAddress')
  private emitAddress(address: string, target: string, index?: number) {
  }
}
